// reactstrap components
import { Card, CardBody, CardTitle, Container, Row, Col, Table, Badge } from "reactstrap";
import { useState } from "react";

const AddClubHeader = ({ tableData, isMobile = false }) => {
  const [showDetails, setShowDetails] = useState(false);
  const lowBatteryCount = tableData?.rows?.length || 0;

  // Mobile compact header
  if (isMobile) {
    return (
      <div
        className="header-mobile-sticky shadow"
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          padding: '0.75rem 1rem',
          backgroundImage: "url(" + require("../../assets/img/theme/admin-cover.jpg") + ")",
          backgroundSize: "cover",
          backgroundPosition: "center top",
          borderBottom: '2px solid rgba(255,255,255,0.1)',
          position: 'relative',
        }}
      >
        {/* Mask overlay for better text readability */}
        <span className="mask bg-gradient-default opacity-6" style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 0 }} />
        
        <div className="d-flex justify-content-between align-items-center" style={{ position: 'relative', zIndex: 1 }}>
          <div className="d-flex align-items-center">
            <i className="ni ni-world-2 text-white" style={{ fontSize: '1.5rem', marginRight: '0.75rem' }}></i>
            <div>
              <h6 className="mb-0 text-white" style={{ fontSize: '0.875rem', fontWeight: 600, letterSpacing: '0.5px' }}>
                CLUB DASHBOARD
              </h6>
              {lowBatteryCount > 0 && (
                <small className="text-white" style={{ fontSize: '0.75rem', opacity: 0.85 }}>
                  {lowBatteryCount} tracker{lowBatteryCount !== 1 ? 's' : ''} low battery
                </small>
              )}
            </div>
          </div>
          {lowBatteryCount > 0 && (
            <div style={{ cursor: 'pointer' }} onClick={() => setShowDetails(!showDetails)}>
              <Badge
                color="warning"
                className="badge-circle"
                style={{
                  width: '2rem',
                  height: '2rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '0.875rem',
                  fontWeight: 'bold',
                  position: 'relative',
                }}
              >
                {lowBatteryCount}
                <i 
                  className={`ni ${showDetails ? 'ni-bold-up' : 'ni-bold-down'} text-white`} 
                  style={{ 
                    position: 'absolute', 
                    bottom: '-3px', 
                    right: '-3px', 
                    fontSize: '0.6rem',
                    backgroundColor: '#11cdef',
                    borderRadius: '50%',
                    width: '16px',
                    height: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '2px solid rgba(255,255,255,0.3)'
                  }}
                />
              </Badge>
            </div>
          )}
        </div>
        
        {/* Expandable details section */}
        {showDetails && lowBatteryCount > 0 && (
          <div className="mt-3" style={{ backgroundColor: 'rgba(255,255,255,0.98)', borderRadius: '0.375rem', padding: '0.75rem', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', position: 'relative', zIndex: 1 }}>
            <h6 className="mb-2" style={{ fontSize: '0.875rem', color: '#32325d', fontWeight: 600 }}>
              GPS Trackers with Low Battery
            </h6>
            <div className="table-responsive">
              <Table size="sm" className="mb-0" bordered hover>
                <thead className="thead-light">
                  <tr>
                    {Object.values(tableData.cols).map((value, idx) => (
                      <th key={idx} style={{ fontSize: '0.75rem', padding: '0.5rem', color: '#8898aa', fontWeight: 600, textTransform: 'uppercase' }}>
                        {value}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {tableData.rows.map((row, idx) => (
                    <tr key={idx}>
                      {Object.keys(tableData.cols).map((key, colIdx) => (
                        <td key={colIdx} style={{ fontSize: '0.75rem', padding: '0.5rem', color: '#525f7f' }}>
                          {row[key]}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        )}
      </div>
    );
  }

  // Desktop full header
  return (
    <>
      <div
        className="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
        style={{
          minHeight: "400px",
          backgroundImage:
            "url(" +
            require("../../assets/img/theme/admin-cover.jpg") +
            ")",
          backgroundSize: "cover",
          backgroundPosition: "center top",
        }}
      >
        {/* Mask */}
        <span className="mask bg-gradient-default opacity-5" />
        {tableData && (
          <Container fluid>
            <div className="header-body">
              <Row style={{justifyContent: "space-between"}}>
                <Col lg="7" xl="4">
                  <Card className="card-stats mb-4 mb-xl-0 shadow">
                    <CardBody>
                      <CardTitle tag="h4" className="mb-4">
                        GPS Trackers with Low Battery
                      </CardTitle>
                      <div className="table-responsive">
                        <Table className="align-items-center" bordered hover size="sm">
                          <thead className="thead-light">
                            <tr>
                              {Object.values(tableData.cols).map((value, idx) => (
                                <th key={idx} scope="col">
                                  {value}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {tableData.rows.slice(0,7).map((row, idx) => (
                              <tr key={idx}>
                                {Object.keys(tableData.cols).map((key, colIdx) => (
                                  <td key={colIdx}>{row[key]}</td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                { tableData?.rows?.length > 7 &&
                  <Col lg="7" xl="4">
                    <Card className="card-stats mb-4 mb-xl-0 shadow">
                      <CardBody>
                        <CardTitle tag="h4" className="mb-4">
                          GPS Trackers with Low Battery
                        </CardTitle>
                        <div className="table-responsive">
                          <Table className="align-items-center" bordered hover size="sm">
                            <thead className="thead-light">
                              <tr>
                                {Object.values(tableData.cols).map((value, idx) => (
                                  <th key={idx} scope="col">
                                    {value}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {tableData.rows.slice(7,14).map((row, idx) => (
                                <tr key={idx}>
                                  {Object.keys(tableData.cols).map((key, colIdx) => (
                                    <td key={colIdx}>{row[key]}</td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                }
              </Row>
            </div>
          </Container>
        )}
      </div>
    </>
  );
};

export default AddClubHeader;
